import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// Basic Components
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import CardSimple from 'screens/components/basic/CardSimple';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';

const componentName = "HourlySalesSecondary";

const Header = ({ showBody, download }) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-4 col-sm-4 col-md-3 col-lg-4 col-xl-3">
                <DatePickerInput
                    name={componentName + "StartDate"}
                    floatingLabelText={"Start Date"}
                    hintText={"Start Date"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-4 col-sm-4 col-md-3 col-lg-4 col-xl-3">
                <DatePickerInput
                    name={componentName + "EndDate"}
                    floatingLabelText={"End Date"}
                    hintText={"End Date"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-4 col-sm-4 col-md-3 col-lg-4 col-xl-6">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={download}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;
